<div [className]="data.catalog ? 'menu-container-2' : 'menu-container'">
  <div class="modal-header-filters w-100 mb-3">
    <div class="modal-title">
      <span class="title-bottomsheet">Sort</span>
    </div>
    <div class="modal-header-filters__right">
      <i class="close btn-close" (click)="onNoClick()"></i>
    </div>
  </div>
  <div class="mt-3 menu-content-mobile animate__animated animate__fadeIn">
    <button
      *ngIf="data.catalog"
      mat-menu-item
      (click)="sortOrders(data.sortType.MOSTORDERED)"
    >
      <span class="menu-label-btn">Most ordered</span>
    </button>
    <button
      *ngIf="data.catalog"
      mat-menu-item
      (click)="sortOrders(data.sortType.MOSTRECENT)"
    >
      <span class="menu-label-btn">Recent orders</span>
    </button>
    <button mat-menu-item (click)="sortOrders(data.sortType.ASCENDING)">
      <span class="menu-label-btn">ASCENDING</span>
    </button>
    <button mat-menu-item (click)="sortOrders(data.sortType.DESCENDING)">
      <span class="menu-label-btn">DESCENDING</span>
    </button>
  </div>
</div>
